import { useFetch } from "@app/framework/hooks";
import { apiUrls } from "@app/shared";
import fileImg from "@assets/images/file.png";
import { TextInput } from "@design-system/components/Form";
import { useSearch } from "@modules/general-assembly/hooks";
import { MinutesOfMeetingsAvailable } from "@modules/general-assembly/types";
import { Loading, NoDataFound } from "@modules/shared/components";
import { getLocalizedValue } from "@modules/shared/utils";
import { getCurrentLocaleCode, trans } from "@mongez/localization";
import { useCallback, useEffect, useId, useState } from "react";

type Data = {
  records: MinutesOfMeetingsAvailable[];
};

export function MinutesOfMeetingsAvailableTab() {
  const locale = getCurrentLocaleCode();
  const [filteredData, setFilteredData] = useState<
    MinutesOfMeetingsAvailable[]
  >([]);
  const { data, load, isLoading } = useFetch<Data>(
    apiUrls.generalAssembly.minutesOfMeetingsAvailable,
  );

  useEffect(() => {
    load().then((data) => {
      setFilteredData(data?.records || []);
    });
  }, [locale]);

  const onSearch = useCallback(
    (value: string) => {
      if (!value) {
        return setFilteredData(data?.records || []);
      }

      if (data?.records) {
        setFilteredData(
          data.records.filter((item) => {
            return getLocalizedValue(item.title)
              .toLowerCase()
              .includes(value.toLowerCase());
          }),
        );
      } else {
        setFilteredData([]);
      }
    },
    [data],
  );

  const { search, handleSearch } = useSearch({
    onSearch,
  });

  return (
    <div className="flex animate-fade flex-col gap-6 rounded-3xl bg-white p-4 md:gap-8 md:p-8">
      {/* <div className="flex justify-end">
        <TextInput
          classes={{
            input:
              "max-w-sm border ms-auto border-gray-300 text-marine placeholder:text-gray-500",
          }}
          name="search"
          placeholder={trans("search")}
          onChange={handleSearch}
          value={search}
        />
      </div> */}
      {isLoading ? (
        <Loading />
      ) : filteredData && filteredData.length > 0 ? (
        // <FancyBox>
        <div className="grid grid-cols-[repeat(auto-fill,minmax(220px,1fr))] gap-4">
          {filteredData.map((minutesOfMeetingsAvailable, index) => (
            <MinutesOfMeetingsAvailableItem
              key={index}
              minutesOfMeetingsAvailable={minutesOfMeetingsAvailable}
            />
          ))}
        </div>
      ) : (
        // </FancyBox>
        <NoDataFound />
      )}
    </div>
  );
}

type MinutesOfMeetingsAvailableItemProps = {
  minutesOfMeetingsAvailable: MinutesOfMeetingsAvailable;
};

function MinutesOfMeetingsAvailableItem({
  minutesOfMeetingsAvailable,
}: MinutesOfMeetingsAvailableItemProps) {
  const id = useId();
  return (
    <a
      data-fancybox="financial-statements"
      data-src={getLocalizedValue(minutesOfMeetingsAvailable.pdf)}
      href={getLocalizedValue(minutesOfMeetingsAvailable.pdf)}
      target="_blank"
      rel="noopener noreferrer"
      className="group flex animate-fade cursor-pointer flex-col items-center gap-4 rounded-2xl border border-[#E0E0E0] bg-white p-4 shadow-sm transition-colors duration-300 hover:bg-gray-100"
    >
      {" "}
      {/* <a
        data-fancybox={id}
        data-src={getLocalizedValue(minutesOfMeetingsAvailable.pdf)}
        href={getLocalizedValue(minutesOfMeetingsAvailable.pdf)}
        target="_blank"
        rel="noopener noreferrer"
        className="h-64 shrink-0 overflow-hidden rounded-xl"
      >
        <img
          src={
            getLocalizedValue(minutesOfMeetingsAvailable.image || "") || formImg
          }
          alt={getLocalizedValue(minutesOfMeetingsAvailable.title)}
          width={180}
          height={250}
          className="h-full w-full object-cover transition-all duration-300 group-hover:scale-105"
        />
      </a> */}
      {/* <div className="flex size-20 items-center justify-center">
        <img src={fileImg} alt="file" className="mt-5 size-10" />
      </div> */}
      <div className="flex flex-col gap-2">
        <p className="text-center font-semibold text-marine">
          {trans(minutesOfMeetingsAvailable.title)}
        </p>
      </div>
    </a>
  );
}
